import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { decrypt, encrypt } from "../utilities/Encriptacion";
import AuthRoutes from "./AuthRoutes/AuthRoutes";
import GuestRoutes from "./GuestRoutes/GuestRoutes";

const MainRouter = () => {
    const [auth, setAuth] = useState(false)
    useEffect(() => {
        const clave = process.env.REACT_APP_CLAVE_ENCRYPTION
        if (sessionStorage.getItem('auth')) {
            const autLocal = sessionStorage.getItem('auth')
            if (decrypt(autLocal, clave) === "false") {
                setAuth(false)
            }
            else {
                setAuth(true)
            }
        }
        else {
            sessionStorage.setItem('auth', encrypt(`${auth}`, clave));
        }
    }, [auth])
    return (
        <BrowserRouter>
                {
                    auth ? (
                        <AuthRoutes/>
                    ) : (
                        <GuestRoutes/>
                    )
                }
        </BrowserRouter>
    )
}

export default MainRouter
